// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"455":"DetailCamera","771":"RegistryView"}[chunkId] || chunkId) + "." + {"100":"41671317","455":"a9976515","771":"c7e1c178"}[chunkId] + ".css";
};